import React, { useMemo } from "react";
import { ComponentStyleProps } from "../../../../lib/styles/props/component-style-props";
import { CalendarIcon } from "@chakra-ui/icons";
import {
  ComponentMultiStyleConfig,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { SystemStyleObject } from "@chakra-ui/styled-system";

export type CMCustomDatePickerInputProps = {
  size?: "sm" | "md" | "lg";

  disabled_?: boolean; // 原因は不明だが、 "disabled"という名前だと正しく動かないため、このようなネーミングとしている。
  isInvalid?: boolean;

  placeholder?: string;
  value?: string;
  icon?: React.ReactElement;
  onClick?: () => void;
  onInput?: (inputValue: string) => void;
  onBlur?: () => void;

  /**
   * 入力エリアのスタイル。
   */
  inputStyles?: SystemStyleObject;
} & ComponentStyleProps;

/**
 * React Date-Pickerのカスタムレイアウト用のコンポーネント
 */
export const CMCustomDatePickerInput = React.forwardRef<
  HTMLInputElement,
  CMCustomDatePickerInputProps
>(function CustomInput(
  {
    size = "md",

    disabled_: disabled,
    isInvalid,

    value,

    icon = <CalendarIcon />,
    placeholder,

    onClick,
    onInput,
    onBlur,

    inputStyles,

    sx,
    ...rest
  }: CMCustomDatePickerInputProps,
  ref,
) {
  const styles = useMultiStyleConfig("CMCustomDatePickerInputStyles", {
    size,
  });

  const containerStyles = useMemo(() => {
    return { ...styles.container, ...sx };
  }, [styles, sx]);
  const _inputStyles = useMemo(() => {
    return { ...styles.input, ...inputStyles };
  }, [styles, inputStyles]);

  return (
    <InputGroup size={size} sx={containerStyles} {...rest}>
      <Input
        disabled={disabled}
        isInvalid={isInvalid}
        size={size}
        placeholder={placeholder}
        value={value}
        onClick={onClick}
        onChange={(e) => {
          onInput?.(e.target.value);
        }}
        onBlur={onBlur}
        ref={ref}
        sx={_inputStyles}
      />
      {!disabled && (
        <InputRightElement sx={styles.iconWrap} pointerEvents="none">
          <IconButton
            size={size}
            disabled={disabled}
            aria-label="calendar-button"
            icon={icon}
            onClick={onClick}
            onBlur={onBlur}
            variant="ghost"
            sx={styles.icon}
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
});

export const CMCustomDatePickerInputStyles: ComponentMultiStyleConfig = {
  parts: ["inputGroup", "input", "iconWrap", "icon"],
  baseStyle: {
    inputGroup: {
      _placeholder: {
        color: "blackAlpha.500",
      },
    },
    input: {
      bgColor: "white",
    },
    iconWrap: {},
  },
  sizes: {
    sm: {
      inputGroup: {},
      input: {},
      icon: {},
    },
    md: {
      inputGroup: {},
      input: {},
      icon: {},
    },
    lg: {
      inputGroup: {},
      input: {},
      icon: {},
    },
  },
};
